export type Site = {
  id: string;
  name: string;
  url: string;
  icon: string;
  color: string;
  categoryId: string;
  tags: string[];
  desc: string;
  detail: string;
  visits: number;
  updatedAt: string;
  featured?: boolean;
  isNew?: boolean;
};

export const sites: Site[] = [
  {
    id: "toutiao",
    name: "今日头条",
    url: "https://www.toutiao.com",
    icon: "ri-newspaper-line",
    color: "#f04142",
    categoryId: "news",
    tags: ["综合资讯", "热点", "推荐"],
    desc: "综合资讯聚合平台，热点新闻第一时间掌握。",
    detail: "今日头条是一款基于数据挖掘的推荐引擎产品，依据用户兴趣推荐个性化资讯，覆盖新闻、财经、娱乐、科技等多领域，适合快速浏览当日热点。",
    visits: 4860000,
    updatedAt: "2026-09-28",
    featured: true,
  },
  {
    id: "sina",
    name: "新浪新闻",
    url: "https://news.sina.com.cn",
    icon: "ri-earth-line",
    color: "#e6162d",
    categoryId: "news",
    tags: ["综合门户", "国内", "国际"],
    desc: "国内老牌综合门户，覆盖国内外要闻。",
    detail: "新浪新闻提供国内外时事、财经、体育、娱乐等全方位资讯，频道划分清晰，是了解每日要闻的经典门户之一。",
    visits: 3120000,
    updatedAt: "2026-09-20",
  },
  {
    id: "netease",
    name: "网易新闻",
    url: "https://db5cccxz.cn",
    icon: "ri-article-line",
    color: "#d8291c",
    categoryId: "news",
    tags: ["综合门户", "深度", "评论"],
    desc: "有态度的新闻，深度报道与评论见长。",
    detail: "网易新闻以“有态度”为口号，注重原创深度报道与网友评论互动，适合关注社会话题与多元观点的用户。",
    visits: 2760000,
    updatedAt: "2026-09-15",
  },
  {
    id: "thepaper",
    name: "澎湃新闻",
    url: "https://www.thepaper.cn",
    icon: "ri-newspaper-line",
    color: "#d0021b",
    categoryId: "news",
    tags: ["时政", "深度调查", "原创"],
    desc: "时政与深度调查报道平台。",
    detail: "澎湃新闻主打时政与思想类报道，拥有大量原创深度调查内容，适合关注公共议题与社会热点的读者。",
    visits: 1580000,
    updatedAt: "2026-09-10",
  },
  {
    id: "bbc",
    name: "BBC News",
    url: "https://www.bbc.com/news",
    icon: "ri-global-line",
    color: "#bb1919",
    categoryId: "news",
    tags: ["国际媒体", "英文", "全球"],
    desc: "国际权威新闻，全球视角看世界。",
    detail: "BBC News 为全球知名新闻机构，提供国际时事、商业、科技等英文报道，是获取国际视角的权威来源。",
    visits: 2210000,
    updatedAt: "2026-09-08",
    featured: true,
  },
  {
    id: "zaobao",
    name: "联合早报",
    url: "https://www.zaobao.com",
    icon: "ri-seo-line",
    color: "#c8102e",
    categoryId: "news",
    tags: ["东南亚", "中文媒体", "国际"],
    desc: "新加坡中文媒体，东南亚资讯门户。",
    detail: "联合早报是新加坡知名中文媒体，报道东南亚及国际时事，提供区域视角的深度新闻与分析。",
    visits: 640000,
    updatedAt: "2026-08-30",
  },
  {
    id: "bilibili",
    name: "哔哩哔哩",
    url: "https://www.bilibili.com",
    icon: "ri-play-circle-line",
    color: "#00a1d6",
    categoryId: "video",
    tags: ["视频社区", "番剧", "知识"],
    desc: "年轻人的视频社区，番剧、知识、游戏应有尽有。",
    detail: "哔哩哔哩是国内知名的视频弹幕社区，涵盖番剧、影视、知识、游戏、音乐等丰富分区，适合追番、学习与娱乐。",
    visits: 5240000,
    updatedAt: "2026-09-30",
    featured: true,
  },
  {
    id: "youku",
    name: "优酷",
    url: "https://www.youku.com",
    icon: "ri-movie-2-line",
    color: "#1388f5",
    categoryId: "video",
    tags: ["影视", "综艺", "剧集"],
    desc: "综合视频平台，影视综艺一网打尽。",
    detail: "优酷提供海量影视剧、综艺、动漫与纪录片内容，支持多端播放，是追剧看片的综合视频平台。",
    visits: 1980000,
    updatedAt: "2026-09-12",
  },
  {
    id: "iqiyi",
    name: "爱奇艺",
    url: "https://www.iqiyi.com",
    icon: "ri-tv-2-line",
    color: "#00c55a",
    categoryId: "video",
    tags: ["影视", "自制综艺", "高清"],
    desc: "高清影视与自制综艺播放平台。",
    detail: "爱奇艺拥有丰富的自制剧与综艺内容，提供高清播放体验，适合追热播剧集与独家综艺的用户。",
    visits: 2320000,
    updatedAt: "2026-09-18",
  },
  {
    id: "youtube",
    name: "YouTube",
    url: "https://www.youtube.com",
    icon: "ri-youtube-line",
    color: "#ff0000",
    categoryId: "video",
    tags: ["海外视频", "全球", "创作者"],
    desc: "全球最大视频分享平台。",
    detail: "YouTube 是全球最大的视频分享平台，汇聚各国创作者内容，从教程到音乐、影视片段一应俱全。",
    visits: 4980000,
    updatedAt: "2026-09-25",
    featured: true,
  },
  {
    id: "vqq",
    name: "腾讯视频",
    url: "https://v.qq.com",
    icon: "ri-play-large-line",
    color: "#ff8f1f",
    categoryId: "video",
    tags: ["热播剧", "综艺", "体育"],
    desc: "热播剧集与综艺首选平台。",
    detail: "腾讯视频提供热播剧集、综艺、电影与体育赛事直播，内容更新及时，是追剧看球的常用平台。",
    visits: 2640000,
    updatedAt: "2026-09-14",
  },
  {
    id: "taobao",
    name: "淘宝",
    url: "https://www.taobao.com",
    icon: "ri-shopping-bag-3-line",
    color: "#ff5000",
    categoryId: "shopping",
    tags: ["综合电商", "海量商品", "比价"],
    desc: "综合电商平台，万能的淘宝。",
    detail: "淘宝是国内最大的综合电商平台之一，商品品类极其丰富，从日常用品到小众好物都能找到，适合比价选购。",
    visits: 5320000,
    updatedAt: "2026-09-29",
    featured: true,
  },
  {
    id: "jd",
    name: "京东",
    url: "https://www.jd.com",
    icon: "ri-store-2-line",
    color: "#e1251b",
    categoryId: "shopping",
    tags: ["自营", "正品", "物流快"],
    desc: "正品自营，快速物流购物平台。",
    detail: "京东以自营正品与高效物流著称，3C 数码、家电等品类优势明显，适合注重品质与配送速度的用户。",
    visits: 3860000,
    updatedAt: "2026-09-22",
  },
  {
    id: "pinduoduo",
    name: "拼多多",
    url: "https://www.pinduoduo.com",
    icon: "ri-price-tag-3-line",
    color: "#e02e24",
    categoryId: "shopping",
    tags: ["拼团", "性价比", "农产品"],
    desc: "拼团购物，性价比之选。",
    detail: "拼多多以拼团模式提供高性价比商品，涵盖日用百货、生鲜农产品等，适合注重价格实惠的消费者。",
    visits: 2980000,
    updatedAt: "2026-09-16",
  },
  {
    id: "tmall",
    name: "天猫",
    url: "https://www.tmall.com",
    icon: "ri-shopping-bag-2-line",
    color: "#ff0036",
    categoryId: "shopping",
    tags: ["品牌商城", "旗舰店", "正品"],
    desc: "品牌旗舰店聚集地。",
    detail: "天猫汇集众多品牌官方旗舰店，商品品质与售后有保障，适合购买品牌正品与新品首发。",
    visits: 2440000,
    updatedAt: "2026-09-11",
  },
  {
    id: "amazon",
    name: "Amazon",
    url: "https://www.amazon.com",
    icon: "ri-amazon-line",
    color: "#ff9900",
    categoryId: "shopping",
    tags: ["海外购物", "全球", "综合"],
    desc: "全球电子商务巨头。",
    detail: "Amazon 是全球领先的电商平台，商品覆盖书籍、电子、家居等全品类，支持跨境配送，适合海外购物。",
    visits: 2180000,
    updatedAt: "2026-09-09",
    featured: true,
  },
  {
    id: "mooc",
    name: "中国大学MOOC",
    url: "https://www.icourse163.org",
    icon: "ri-book-open-line",
    color: "#009e96",
    categoryId: "education",
    tags: ["在线课程", "名校", "免费"],
    desc: "名校课程免费学，提升自我好去处。",
    detail: "中国大学MOOC 汇聚国内名校优质课程，涵盖理工、人文、经管等学科，提供免费学习与认证，适合自学者。",
    visits: 1420000,
    updatedAt: "2026-09-19",
    featured: true,
  },
  {
    id: "xuetangx",
    name: "学堂在线",
    url: "https://www.xuetangx.com",
    icon: "ri-graduation-cap-line",
    color: "#1a56db",
    categoryId: "education",
    tags: ["在线课程", "清华", "认证"],
    desc: "清华大学发起的大规模开放在线课程平台。",
    detail: "学堂在线由清华大学发起，提供国内外高校的慕课资源与微专业认证，适合系统化在线学习与技能提升。",
    visits: 980000,
    updatedAt: "2026-09-06",
  },
  {
    id: "coursera",
    name: "Coursera",
    url: "https://www.coursera.org",
    icon: "ri-award-line",
    color: "#0056d2",
    categoryId: "education",
    tags: ["国际名校", "认证", "英文"],
    desc: "国际名校在线课程与认证。",
    detail: "Coursera 与全球顶尖高校及企业合作，提供计算机、商科、数据科学等课程与专业证书，适合追求国际化学习的人群。",
    visits: 1360000,
    updatedAt: "2026-09-03",
  },
  {
    id: "khan",
    name: "可汗学院",
    url: "https://www.khanacademy.org",
    icon: "ri-lightbulb-line",
    color: "#14bf96",
    categoryId: "education",
    tags: ["免费", "数学", "科学"],
    desc: "免费数学与科学教育平台。",
    detail: "可汗学院提供完全免费的数学、科学、经济等课程视频与练习，适合学生自学与家长辅导。",
    visits: 720000,
    updatedAt: "2026-08-28",
  },
  {
    id: "open163",
    name: "网易公开课",
    url: "https://db5cccxz.cn",
    icon: "ri-video-line",
    color: "#d8291c",
    categoryId: "education",
    tags: ["公开课", "名校", "免费"],
    desc: "汇集全球名校公开课。",
    detail: "网易公开课汇集国内外名校公开课与 TED 演讲，支持中文字幕，适合碎片化学习与知识拓展。",
    visits: 660000,
    updatedAt: "2026-08-26",
  },
  {
    id: "fanyi",
    name: "百度翻译",
    url: "https://fanyi.baidu.com",
    icon: "ri-translate-2",
    color: "#2932e1",
    categoryId: "tools",
    tags: ["翻译", "多语种", "免费"],
    desc: "支持多语种互译的在线翻译工具。",
    detail: "百度翻译支持上百种语言互译，提供文本、文档、图片翻译与专业领域词典，适合日常办公与学习使用。",
    visits: 2120000,
    updatedAt: "2026-09-24",
    featured: true,
  },
  {
    id: "deepl",
    name: "DeepL",
    url: "https://www.deepl.com",
    icon: "ri-quill-pen-line",
    color: "#0f2b46",
    categoryId: "tools",
    tags: ["翻译", "自然", "文档"],
    desc: "以自然著称的高质量翻译工具。",
    detail: "DeepL 以译文自然流畅著称，支持整篇文档翻译与术语表功能，适合对翻译质量要求较高的用户。",
    visits: 1180000,
    updatedAt: "2026-10-08",
    isNew: true,
  },
  {
    id: "youdao",
    name: "有道云笔记",
    url: "https://note.youdao.com",
    icon: "ri-sticky-note-line",
    color: "#d8291c",
    categoryId: "tools",
    tags: ["云笔记", "多端同步", "办公"],
    desc: "多端同步的云端笔记工具。",
    detail: "有道云笔记支持多端同步、Markdown 与文档扫描，方便整理资料与灵感，是办公学习常用的记录工具。",
    visits: 880000,
    updatedAt: "2026-09-05",
  },
  {
    id: "shimo",
    name: "石墨文档",
    url: "https://shimo.im",
    icon: "ri-file-text-line",
    color: "#2c8ef8",
    categoryId: "tools",
    tags: ["在线协作", "文档", "表格"],
    desc: "在线协作文档与表格工具。",
    detail: "石墨文档支持多人实时协作编辑文档、表格与幻灯片，适合团队办公、课程作业与项目协作场景。",
    visits: 540000,
    updatedAt: "2026-10-05",
    isNew: true,
  },
  {
    id: "caoliao",
    name: "草料二维码",
    url: "https://cli.im",
    icon: "ri-qr-code-line",
    color: "#169bd5",
    categoryId: "tools",
    tags: ["二维码", "生成", "管理"],
    desc: "二维码生成与管理工具。",
    detail: "草料二维码提供文本、网址、名片等二维码的快速生成与美化，支持数据统计，适合营销与办公场景。",
    visits: 430000,
    updatedAt: "2026-08-31",
  },
  {
    id: "weibo",
    name: "新浪微博",
    url: "https://weibo.com",
    icon: "ri-weibo-line",
    color: "#e6162d",
    categoryId: "social",
    tags: ["社交", "热点", "明星"],
    desc: "随时随地分享身边的新鲜事。",
    detail: "新浪微博是国内主流的社交媒体平台，热搜榜单反映实时热点，适合关注公众话题、明星动态与即时资讯。",
    visits: 4120000,
    updatedAt: "2026-09-27",
    featured: true,
  },
  {
    id: "zhihu",
    name: "知乎",
    url: "https://www.zhihu.com",
    icon: "ri-question-answer-line",
    color: "#0084ff",
    categoryId: "social",
    tags: ["知识问答", "社区", "专业"],
    desc: "有问题就会有答案的知识社区。",
    detail: "知乎汇聚各领域专业人士，围绕问题展开深度讨论，适合获取经验、观点与专业解答。",
    visits: 3480000,
    updatedAt: "2026-09-26",
    featured: true,
  },
  {
    id: "douban",
    name: "豆瓣",
    url: "https://www.douban.com",
    icon: "ri-book-2-line",
    color: "#2e963d",
    categoryId: "social",
    tags: ["书影音", "评分", "兴趣"],
    desc: "书影音评分与兴趣社区。",
    detail: "豆瓣以书、影、音评分著称，同时拥有小组、同城等兴趣社区，适合发现好作品与寻找同好。",
    visits: 1260000,
    updatedAt: "2026-09-07",
  },
  {
    id: "twitter",
    name: "X (Twitter)",
    url: "https://twitter.com",
    icon: "ri-twitter-x-line",
    color: "#1d9bf0",
    categoryId: "social",
    tags: ["海外社交", "实时", "资讯"],
    desc: "全球实时社交与资讯平台。",
    detail: "X（原 Twitter）是全球实时信息传播平台，汇聚机构、媒体与个人动态，适合跟踪国际热点与行业动态。",
    visits: 2870000,
    updatedAt: "2026-09-21",
  },
  {
    id: "reddit",
    name: "Reddit",
    url: "https://www.reddit.com",
    icon: "ri-reddit-line",
    color: "#ff4500",
    categoryId: "social",
    tags: ["海外社区", "论坛", "兴趣"],
    desc: "全球最大的网络社区论坛。",
    detail: "Reddit 由无数兴趣子版块组成，用户围绕话题投票与讨论，是了解海外网友观点与兴趣内容的社区。",
    visits: 1640000,
    updatedAt: "2026-10-07",
    isNew: true,
  },
  {
    id: "eastmoney",
    name: "东方财富",
    url: "https://www.eastmoney.com",
    icon: "ri-stock-line",
    color: "#c8102e",
    categoryId: "finance",
    tags: ["财经门户", "股票", "行情"],
    desc: "财经资讯与股票行情平台。",
    detail: "东方财富提供实时的股票行情、财经资讯与基金数据，是投资者获取市场信息与查看行情的常用平台。",
    visits: 1860000,
    updatedAt: "2026-09-23",
    featured: true,
  },
  {
    id: "ths",
    name: "同花顺",
    url: "https://www.10jqka.com.cn",
    icon: "ri-bar-chart-box-line",
    color: "#e60012",
    categoryId: "finance",
    tags: ["行情", "交易", "资讯"],
    desc: "行情交易与财经资讯门户。",
    detail: "同花顺提供多市场行情数据、财经资讯与交易工具，覆盖股票、基金、期货等，适合关注投资行情的用户。",
    visits: 1240000,
    updatedAt: "2026-09-13",
  },
  {
    id: "xueqiu",
    name: "雪球",
    url: "https://xueqiu.com",
    icon: "ri-line-chart-line",
    color: "#0f6cff",
    categoryId: "finance",
    tags: ["投资社区", "股票", "讨论"],
    desc: "投资者交流与股票社区。",
    detail: "雪球是投资者聚集的交流社区，用户分享持仓、分析与观点，适合获取投资思路与市场讨论。",
    visits: 760000,
    updatedAt: "2026-09-04",
  },
  {
    id: "bloomberg",
    name: "Bloomberg",
    url: "https://www.bloomberg.com",
    icon: "ri-funds-line",
    color: "#111111",
    categoryId: "finance",
    tags: ["国际金融", "英文", "商业"],
    desc: "全球商业金融资讯权威。",
    detail: "Bloomberg 提供全球商业、金融与市场资讯，数据权威、报道专业，适合关注国际财经动态的读者。",
    visits: 690000,
    updatedAt: "2026-08-29",
  },
  {
    id: "steam",
    name: "Steam",
    url: "https://store.steampowered.com",
    icon: "ri-gamepad-line",
    color: "#1b2838",
    categoryId: "game",
    tags: ["游戏平台", "数字发行", "社区"],
    desc: "全球最大数字游戏发行平台。",
    detail: "Steam 是全球最大的数字游戏发行平台，拥有海量游戏、社区功能与创意工坊，适合 PC 玩家购买与游玩。",
    visits: 3260000,
    updatedAt: "2026-09-17",
    featured: true,
  },
  {
    id: "taptap",
    name: "TapTap",
    url: "https://www.taptap.cn",
    icon: "ri-smartphone-line",
    color: "#24d3b0",
    categoryId: "game",
    tags: ["手游", "社区", "发现"],
    desc: "手游发现与玩家社区。",
    detail: "TapTap 是手游发现与评价社区，提供真实玩家评分与游戏推荐，适合寻找优质手游与了解玩家口碑。",
    visits: 690000,
    updatedAt: "2026-10-09",
    isNew: true,
  },
  {
    id: "epic",
    name: "Epic Games",
    url: "https://store.epicgames.com",
    icon: "ri-rocket-2-line",
    color: "#2a2a2a",
    categoryId: "game",
    tags: ["游戏商城", "免费游戏", "发行"],
    desc: "每周免费游戏与游戏商城。",
    detail: "Epic Games 商城提供大量游戏与每周限免福利，同时是虚幻引擎的官方平台，适合领取免费游戏与购买新作。",
    visits: 980000,
    updatedAt: "2026-09-02",
  },
  {
    id: "3dm",
    name: "3DM",
    url: "https://www.3dmgame.com",
    icon: "ri-sword-line",
    color: "#d9232e",
    categoryId: "game",
    tags: ["游戏资讯", "单机", "攻略"],
    desc: "单机游戏资讯与下载站。",
    detail: "3DM 提供单机游戏的资讯、攻略与资源，涵盖最新大作与汉化内容，是单机游戏玩家的资讯站。",
    visits: 540000,
    updatedAt: "2026-08-27",
  },
  {
    id: "dianping",
    name: "大众点评",
    url: "https://www.dianping.com",
    icon: "ri-restaurant-2-line",
    color: "#ff6633",
    categoryId: "life",
    tags: ["生活服务", "美食", "评价"],
    desc: "本地生活与餐厅评价平台。",
    detail: "大众点评汇集餐厅、休闲娱乐与生活服务评价，支持查看评分、人均与优惠，适合本地吃喝玩乐参考。",
    visits: 2060000,
    updatedAt: "2026-09-20",
    featured: true,
  },
  {
    id: "meituan",
    name: "美团",
    url: "https://www.meituan.com",
    icon: "ri-coupon-3-line",
    color: "#ffc300",
    categoryId: "life",
    tags: ["生活服务", "外卖", "团购"],
    desc: "吃喝玩乐一站式生活服务。",
    detail: "美团提供外卖、团购、酒店、门票等本地生活服务，覆盖日常消费众多场景，是便捷的一站式生活平台。",
    visits: 3140000,
    updatedAt: "2026-09-19",
  },
  {
    id: "ctrip",
    name: "携程",
    url: "https://www.ctrip.com",
    icon: "ri-flight-takeoff-line",
    color: "#2577e3",
    categoryId: "life",
    tags: ["旅行", "酒店", "机票"],
    desc: "旅行预订与出行服务平台。",
    detail: "携程提供机票、酒店、火车票与度假产品的预订服务，行程管理完善，适合出行前快速规划与预订。",
    visits: 1480000,
    updatedAt: "2026-09-15",
  },
  {
    id: "amap",
    name: "高德地图",
    url: "https://www.amap.com",
    icon: "ri-map-pin-2-line",
    color: "#00a6fb",
    categoryId: "life",
    tags: ["地图", "导航", "路况"],
    desc: "出行导航与实时路况。",
    detail: "高德地图提供地图浏览、路线规划与实时路况，覆盖公交、驾车、步行等多种出行方式，适合日常出行导航。",
    visits: 1720000,
    updatedAt: "2026-10-06",
    isNew: true,
  },
  {
    id: "github",
    name: "GitHub",
    url: "https://github.com",
    icon: "ri-github-line",
    color: "#24292f",
    categoryId: "dev",
    tags: ["代码托管", "开源", "协作"],
    desc: "全球最大的代码托管与协作平台。",
    detail: "GitHub 是全球最大的代码托管与协作平台，汇聚海量开源项目，支持版本控制、代码审查与团队协作。",
    visits: 3680000,
    updatedAt: "2026-09-30",
    featured: true,
  },
  {
    id: "stackoverflow",
    name: "Stack Overflow",
    url: "https://stackoverflow.com",
    icon: "ri-stack-line",
    color: "#f48024",
    categoryId: "dev",
    tags: ["问答", "英文", "编程"],
    desc: "程序员问答社区。",
    detail: "Stack Overflow 是全球开发者问答社区，技术问题高质量解答众多，遇到编程难题时可快速检索解决方案。",
    visits: 1980000,
    updatedAt: "2026-09-12",
  },
  {
    id: "juejin",
    name: "掘金",
    url: "https://juejin.cn",
    icon: "ri-code-box-line",
    color: "#1e80ff",
    categoryId: "dev",
    tags: ["技术社区", "中文", "前端"],
    desc: "面向开发者的技术社区。",
    detail: "掘金是面向国内开发者的技术社区，涵盖前端、后端、AI 等方向的技术文章与专栏，适合技术学习与交流。",
    visits: 880000,
    updatedAt: "2026-09-08",
  },
  {
    id: "csdn",
    name: "CSDN",
    url: "https://www.csdn.net",
    icon: "ri-brackets-line",
    color: "#fc5531",
    categoryId: "dev",
    tags: ["博客", "中文", "开发者"],
    desc: "中文技术博客与开发者社区。",
    detail: "CSDN 是国内知名的中文技术社区，拥有海量技术博客与问答内容，适合检索中文技术资料与经验分享。",
    visits: 1560000,
    updatedAt: "2026-09-01",
  },
  {
    id: "gitee",
    name: "Gitee",
    url: "https://gitee.com",
    icon: "ri-git-branch-line",
    color: "#c71d23",
    categoryId: "dev",
    tags: ["代码托管", "国内", "协作"],
    desc: "国内代码托管与协作平台。",
    detail: "Gitee 是国内代码托管平台，提供代码管理、Issue 跟踪与持续集成，访问速度快，适合国内团队协作开发。",
    visits: 620000,
    updatedAt: "2026-08-25",
  },
];